import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { CardList } from './@shared/models/card-list';

@Injectable({
  providedIn: 'root',
})
export class TriggerMapZoomService {
  constructor() {}

  private triggerZoomSource = new ReplaySubject<CardList[]>(1);

  triggerZoom(cards: CardList[]) {
    this.triggerZoomSource.next(cards);
  }

  get zoomTriggered$() {
    return this.triggerZoomSource.asObservable();
  }
}
